module.exports = { ...require('./MuiReducer') };
